import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Assets from './pages/Assets';
import Liabilities from './pages/Liabilities';
import Transactions from './pages/Transactions';
import Investments from './pages/Investments';
import RealEstate from './pages/RealEstate';
import Tools from './pages/Tools';
import ToolsLayout from './components/ToolsLayout';
import EmergencyFund from './pages/calculators/EmergencyFund';
import LoanCalculator from './pages/calculators/LoanCalculator';
import InvestmentCalculator from './pages/calculators/InvestmentCalculator';
import BudgetPlanner from './pages/calculators/BudgetPlanner';
import DebtPayoffPlanner from './pages/calculators/DebtPayoffPlanner';
import CapitalGainsCalculator from './pages/calculators/CapitalGainsCalculator';
import MortgageCalculator from './pages/calculators/MortgageCalculator';
import PropertyInvestmentCalculator from './pages/calculators/PropertyInvestmentCalculator';
import RiskToleranceAssessment from './pages/calculators/RiskToleranceAssessment';
import CostBasisCalculator from './pages/calculators/CostBasisCalculator';
import TaxLossHarvestingCalculator from './pages/calculators/TaxLossHarvestingCalculator';
import RetirementCalculator from './pages/calculators/RetirementCalculator';
import RedundancyCalculator from './pages/calculators/RedundancyCalculator';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import About from './pages/About';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Settings from './pages/Settings';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          <Route path="/tools" element={<ToolsLayout />}>
            <Route index element={<Tools />} />
            <Route path="emergency-fund" element={<EmergencyFund />} />
            <Route path="loan-calculator" element={<LoanCalculator />} />
            <Route path="investment-calculator" element={<InvestmentCalculator />} />
            <Route path="budget-planner" element={<BudgetPlanner />} />
            <Route path="debt-payoff" element={<DebtPayoffPlanner />} />
            <Route path="capital-gains" element={<CapitalGainsCalculator />} />
            <Route path="mortgage-calculator" element={<MortgageCalculator />} />
            <Route path="property-investment" element={<PropertyInvestmentCalculator />} />
            <Route path="risk-tolerance" element={<RiskToleranceAssessment />} />
            <Route path="cost-basis" element={<CostBasisCalculator />} />
            <Route path="tax-loss-harvesting" element={<TaxLossHarvestingCalculator />} />
            <Route path="retirement-calculator" element={<RetirementCalculator />} />
            <Route path="redundancy-calculator" element={<RedundancyCalculator />} />
          </Route>
          
          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="assets" element={<Assets />} />
            <Route path="liabilities" element={<Liabilities />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="investments" element={<Investments />} />
            <Route path="real-estate" element={<RealEstate />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Legacy redirect for /app and /app/* */}
          <Route path="/app/*" element={<Navigate to="/dashboard" replace />} />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}